import {
  GET_VENDOR_RETAIL_BOOKINGS,
  GET_VENDOR_RETAIL_BOOKINGS_SUCCESS,
  GET_VENDOR_RETAIL_BOOKINGS_FAILED,
  GET_VENDOR_UNPAID_RETAIL_BOOKINGS,
  GET_VENDOR_UNPAID_RETAIL_BOOKINGS_SUCCESS,
  GET_VENDOR_UNPAID_RETAIL_BOOKINGS_FAILED,
  GET_VENDOR_PAID_RETAIL_BOOKINGS,
  GET_VENDOR_PAID_RETAIL_BOOKINGS_SUCCESS,
  GET_VENDOR_PAID_RETAIL_BOOKINGS_FAILED,
  FIND_VENDOR_RETAIL_BOOKING,
  VENDOR_RETAIL_NOT_BOOKED,
  CREATE_VENDOR_RETAIL_BOOKING,
  CREATE_VENDOR_RETAIL_BOOKING_SUCCESS,
  CREATE_VENDOR_RETAIL_BOOKING_FAILED,
  SET_VENDOR_RETAIL_PAYLOAD,
  SET_TOTAL_BOOKING_AMOUNT,
  CHECK_SLOT_AVAILABILITY,
  CHECK_SLOT_AVAILABILITY_SUCCESS,
  CHECK_SLOT_AVAILABILITY_FAILED,
  CREATE_RETAIL_CHECKOUT_SESSION,
  CREATE_RETAIL_CHECKOUT_SESSION_SUCCESS,
  CREATE_RETAIL_CHECKOUT_SESSION_FAILED,
  CANCEL_RETAIL_BOOKING,
  CANCEL_RETAIL_BOOKING_SUCCESS,
  CANCEL_RETAIL_BOOKING_FAILED,
  RESET_VENDOR_RETAIL,
  GET_VENUE_RETAIL_APPLICATIONS,
  GET_VENUE_RETAIL_APPLICATIONS_SUCCESS,
  GET_VENUE_RETAIL_APPLICATIONS_FAILED,
  UPDATE_RETAIL_APPLICATION_STATUS,
  UPDATE_RETAIL_APPLICATION_STATUS_SUCCESS,
  UPDATE_RETAIL_APPLICATION_STATUS_FAILED,
  VENUE_CANCEL_RETAIL_BOOKING,
  VENUE_CANCEL_RETAIL_BOOKING_SUCCESS,
  VENUE_CANCEL_RETAIL_BOOKING_FAILED,
} from './constants';

const initialState = {
  bookings: [],
  unpaidBookings: [], // For retail payments page
  paidBookings: [], // For retail payments page - Paid tab
  currentBooking: {},
  recentBookings: [], // Track multiple bookings created in the current session
  vendorRetailPayload: {},
  totalBookingAmount: 0,
  checkoutSession: null,
  slotsAvailable: true,
  applications: [], // Venue-side: all applications for the venue
  loading: false,
  error: null,
};

function vendorRetailReducer(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case RESET_VENDOR_RETAIL:
      return initialState;

    case GET_VENDOR_RETAIL_BOOKINGS:
    case GET_VENDOR_UNPAID_RETAIL_BOOKINGS:
    case GET_VENDOR_PAID_RETAIL_BOOKINGS:
    case FIND_VENDOR_RETAIL_BOOKING:
    case CREATE_VENDOR_RETAIL_BOOKING:
    case CHECK_SLOT_AVAILABILITY:
    case CREATE_RETAIL_CHECKOUT_SESSION:
    case CANCEL_RETAIL_BOOKING:
    case GET_VENUE_RETAIL_APPLICATIONS:
    case UPDATE_RETAIL_APPLICATION_STATUS:
    case VENUE_CANCEL_RETAIL_BOOKING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_VENDOR_RETAIL_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload.bookings,
        loading: false,
      };

    case GET_VENDOR_UNPAID_RETAIL_BOOKINGS_SUCCESS:
      return {
        ...state,
        unpaidBookings: action.payload.bookings,
        loading: false,
      };

    case GET_VENDOR_PAID_RETAIL_BOOKINGS_SUCCESS:
      return {
        ...state,
        paidBookings: action.payload.bookings,
        loading: false,
      };

    case CREATE_VENDOR_RETAIL_BOOKING_SUCCESS:
      console.log('🟢 [Reducer] Adding booking to state:', action.payload.booking);
      console.log('🟢 [Reducer] Current recentBookings count:', state.recentBookings.length);
      return {
        ...state,
        currentBooking: action.payload.booking,
        recentBookings: [...state.recentBookings, action.payload.booking],
        loading: false,
      };

    case VENDOR_RETAIL_NOT_BOOKED:
      return {
        ...state,
        currentBooking: {},
        loading: false,
      };

    case SET_VENDOR_RETAIL_PAYLOAD:
      return {
        ...state,
        vendorRetailPayload: { ...state.vendorRetailPayload, ...action.payload },
      };

    case SET_TOTAL_BOOKING_AMOUNT:
      return {
        ...state,
        totalBookingAmount: action.payload.amount,
      };

    case CHECK_SLOT_AVAILABILITY_SUCCESS:
      return {
        ...state,
        slotsAvailable: action.payload.available,
        loading: false,
      };

    case CREATE_RETAIL_CHECKOUT_SESSION_SUCCESS:
      return {
        ...state,
        checkoutSession: action.payload.session,
        loading: false,
      };

    case CANCEL_RETAIL_BOOKING_SUCCESS:
      return {
        ...state,
        currentBooking: action.payload.booking,
        loading: false,
      };

    case GET_VENUE_RETAIL_APPLICATIONS_SUCCESS:
      return {
        ...state,
        applications: action.payload.applications,
        loading: false,
      };

    case UPDATE_RETAIL_APPLICATION_STATUS_SUCCESS:
      return {
        ...state,
        applications: state.applications.map((app) =>
          app.id === action.payload.booking.id ? action.payload.booking : app,
        ),
        loading: false,
      };

    case VENUE_CANCEL_RETAIL_BOOKING_SUCCESS:
      return {
        ...state,
        applications: state.applications.map((app) =>
          app.id === action.payload.booking.id ? action.payload.booking : app,
        ),
        loading: false,
      };

    case GET_VENDOR_RETAIL_BOOKINGS_FAILED:
    case GET_VENDOR_UNPAID_RETAIL_BOOKINGS_FAILED:
    case CREATE_VENDOR_RETAIL_BOOKING_FAILED:
    case CHECK_SLOT_AVAILABILITY_FAILED:
    case CREATE_RETAIL_CHECKOUT_SESSION_FAILED:
    case CANCEL_RETAIL_BOOKING_FAILED:
    case GET_VENUE_RETAIL_APPLICATIONS_FAILED:
    case UPDATE_RETAIL_APPLICATION_STATUS_FAILED:
    case VENUE_CANCEL_RETAIL_BOOKING_FAILED:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
}

export default vendorRetailReducer;
